// Otis 2026-10-03 : choix du point relais Chronopost dans le panier (voir snippets/otis-relais-chronopost.liquid).
// Fichier séparé et chargé par layout/theme.liquid : un <script> placé dans le tiroir panier ne s'exécute pas quand le tiroir est redessiné.
  (function () {
    if (window.otisRelaisPret) return;
    window.otisRelaisPret = true;
    var QG = 'https://blato-contacts.fly.dev/api/public/relais-chronopost';

    function enregistrer(r) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: {
          relais_id: r ? r.id : '', relais_nom: r ? r.nom : '', relais_adresse: r ? r.adresse1 : '',
          relais_cp: r ? r.cp : '', relais_ville: r ? r.ville : ''
        } })
      });
    }

    function afficherChoix(bloc, r) {
      var p = bloc.querySelector('.otis-relais__choisi');
      p.hidden = !r;
      if (!r) return;
      bloc.querySelector('[data-otis-relais-nom]').textContent = r.nom;
      bloc.querySelector('[data-otis-relais-lieu]').textContent = r.adresse1 + ' ' + r.cp + ' ' + r.ville;
    }

    document.addEventListener('click', function (e) {
      var bloc = e.target.closest('.otis-relais');
      if (!bloc) return;
      var message = bloc.querySelector('[data-otis-relais-message]');
      var liste = bloc.querySelector('[data-otis-relais-liste]');

      if (e.target.closest('[data-otis-relais-retirer]')) {
        enregistrer(null).then(function () { afficherChoix(bloc, null); });
        return;
      }

      var choix = e.target.closest('[data-otis-relais-choisir]');
      if (choix) {
        var r = JSON.parse(choix.dataset.otisRelaisChoisir);
        message.textContent = 'Enregistrement…';
        enregistrer(r).then(function (rep) {
          if (!rep.ok) throw new Error();
          afficherChoix(bloc, r);
          liste.replaceChildren();
          message.textContent = 'Relais enregistré.';
        }).catch(function () { message.textContent = 'Le relais n\'a pas pu être enregistré, réessayez.'; });
        return;
      }

      if (!e.target.closest('[data-otis-relais-chercher]')) return;
      var cp = bloc.querySelector('[data-otis-relais-cp]').value.replace(/\s/g, '');
      var ville = bloc.querySelector('[data-otis-relais-ville]').value.trim();
      if (!/^\d{5}$/.test(cp)) { message.textContent = 'Indiquez un code postal à 5 chiffres.'; return; }
      message.textContent = 'Recherche des relais…';
      liste.replaceChildren();
      fetch(QG + '?cp=' + encodeURIComponent(cp) + '&ville=' + encodeURIComponent(ville))
        .then(function (rep) { return rep.json(); })
        .then(function (data) {
          if (!data.relais || !data.relais.length) {
            message.textContent = data.error || 'Aucun relais trouvé près de ce code postal.';
            return;
          }
          message.textContent = data.relais.length + ' relais proches :';
          data.relais.forEach(function (r) {
            var li = document.createElement('li');
            li.style.cssText = 'padding:8px 0;border-top:1px solid rgba(0,0,0,.12);display:flex;gap:8px;justify-content:space-between;align-items:center';
            var texte = document.createElement('span');
            var nom = document.createElement('strong');
            nom.textContent = r.nom;
            texte.append(nom, document.createElement('br'),
              r.adresse1 + ', ' + r.cp + ' ' + r.ville + (r.distance_m ? ' (' + (r.distance_m / 1000).toFixed(1).replace('.', ',') + ' km)' : ''));
            var bouton = document.createElement('button');
            bouton.type = 'button';
            bouton.textContent = 'Choisir';
            bouton.style.cssText = 'padding:6px 10px;cursor:pointer;flex:none';
            bouton.dataset.otisRelaisChoisir = JSON.stringify({ id: r.id, nom: r.nom, adresse1: r.adresse1, cp: r.cp, ville: r.ville });
            li.append(texte, bouton);
            liste.append(li);
          });
        })
        .catch(function () { message.textContent = 'Recherche indisponible pour le moment. Vous pourrez quand même choisir « Chronopost Relais 13 » au paiement : nous prendrons le relais le plus proche de votre adresse.'; });
    });
  })();
